export default __webpack_public_path__ + "static/media/Python.67a96446.png";